<template>
  <div>
    <div v-if="!this.isLoaded">
      <div class="loading_cont_line">
        <div class="spinner">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
      </div>
    </div>

    <div v-else>
      <div style="margin: auto; max-width: 1200px">
        <div style="display: flex">
          <div>
            <div class="a_group">
              <div class="a_title">Répartition des assurés et ayants droit</div>
              <div class="a_list">
                <div v-for="(c, k) in assuresStat" :key="k">
                  <div class="l_list">
                    <a-badge :color="colors[k]" />
                    {{ c.l }}
                  </div>
                  <div class="l_list">
                    <span class="a_n">{{ c.cnt }}</span>
                    <span class="a_p">({{ c.p }} %)</span>
                  </div>
                </div>
              </div>
              <div class="a_stat">
                <div id="regimeStat"></div>
              </div>
            </div>
            <div class="a_group">
              <div class="a_title">
                Répartition de la télétransmission assurés et ayants droit
              </div>
              <div class="a_list">
                <div v-for="(c, k) in connecteStat" :key="k">
                  <div class="l_list">
                    <a-badge :color="colors[k]" />
                    {{ c.l }}
                  </div>
                  <div class="l_list">
                    <span class="a_n">{{ c.cnt }}</span>
                    <span class="a_p">({{ c.p }} %)</span>
                  </div>
                </div>
              </div>
              <div class="a_stat">
                <div id="connecteStat"></div>
              </div>
            </div>
          </div>
          <div>
            <div class="a_group">
              <div class="a_title">Répartition des assurés par catégorie</div>
              <div class="a_list">
                <div v-for="(c, k) in categoryStat" :key="k">
                  <div class="l_list">
                    <a-badge :color="colors[k]" />
                    {{ c.l }}
                  </div>
                  <div class="l_list">
                    <span class="a_n">{{ c.cnt }}</span>
                    <span class="a_p">({{ c.p }} %)</span>
                  </div>
                </div>
              </div>
              <div class="a_stat">
                <div id="categoryStat"></div>
              </div>
            </div>
            <div class="a_group">
              <div class="a_title">Répartition des assurés par collège</div>
              <div class="a_list">
                <div v-for="(c, k) in collegeStat" :key="k">
                  <div class="l_list">
                    <a-badge :color="colors[k]" />
                    {{ c.l }}
                  </div>
                  <div class="l_list">
                    <span class="a_n">{{ c.cnt }}</span>
                    <span class="a_p">({{ c.p }} %)</span>
                  </div>
                </div>
              </div>
              <div class="a_stat">
                <div id="collegeStat"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssureTable",
  data: function () {
    return {
      stat: {
        regime: [],
        connecte: [],
        category: [],
        college: [],
        assure: [],
        benef: 0,
      },

      colors: ["green", "orange", "blue", "yellow", "brown", "red"],

      isLoaded: false,
    };
  },
  methods: {
    createBarStat(div, data) {
      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);
      am4core.options.autoDispose = true;

      var chart = am4core.create(div, am4charts.PieChart);
      chart.innerRadius = am4core.percent(56);
      chart.data = data;
      var pieSeries = chart.series.push(new am4charts.PieSeries());

      pieSeries.dataFields.value = "cnt";
      pieSeries.dataFields.category = "l";
      pieSeries.colorField = "color";
      pieSeries.slices.template.cursorOverStyle = [
        {
          property: "cursor",
          value: "pointer",
        },
      ];
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      pieSeries.colors.list = [
        am4core.color("green"),
        am4core.color("orange"),
        am4core.color("blue"),
        am4core.color("yellow"),
        am4core.color("brown"),
        am4core.color("red"),
      ];

      pieSeries.hiddenState.properties.endAngle = -45;
    },
    showAllAssureByNumContrat(numEntreprise) {
      this.$emit("show-aabne", numEntreprise);
    },
    docs() {
      this.$router.push({
        name: "docs",
        params: {
          num: 789009,
        },
      });
    },
    fo(e, a) {
      e.target.className = "folder " + a + " large brown link icon";
    },
    getTotal(list) {
      var total = 0;
      list.filter((r) => {
        total += parseInt(r.cnt);
      });
      return total;
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
    numHolding() {
      return this.$route.params.numHolding;
    },
    numEntreprise() {
      return this.$route.params.numEntreprise;
    },
    numContrat() {
      return this.$route.params.numContrat;
    },
    regimeStat() {
      var total = this.getTotal(this.stat.regime);
      return this.stat.regime.filter((r) => {
        r.l = this.translate.regime[r.regime];
        r.p = ((r.cnt / total) * 100).toFixed(2);
        return r;
      });
    },
    categoryStat() {
      var total = this.getTotal(this.stat.category);
      return this.stat.category.filter((r) => {
        r.l = this.translate.category[parseInt(r.category)];
        r.p = ((r.cnt / total) * 100).toFixed(2);
        return r;
      });
    },
    collegeStat() {
      var total = this.getTotal(this.stat.college);
      return this.stat.college.filter((r) => {
        r.l = this.translate.college[r.college];
        r.p = ((r.cnt / total) * 100).toFixed(2);
        return r;
      });
    },
    connecteStat() {
      var total = this.getTotal(this.stat.connecte);
      return this.stat.connecte.filter((r) => {
        r.l = this.translate.connecte[r.connecte];
        r.p = ((r.cnt / total) * 100).toFixed(2);
        return r;
      });
    },
    assuresStat() {
      var total =
        parseInt(this.stat.assure.cnt_a) +
        parseInt(this.stat.assure.cnt_c) +
        parseInt(this.stat.assure.cnt_e);

      return [
        {
          cnt: this.stat.assure.cnt_a,
          l: "Assurés",
          p: ((this.stat.assure.cnt_a / total) * 100).toFixed(2),
        },
        {
          cnt: this.stat.assure.cnt_c,
          l: "Conjoints/PACS/Concubins",
          p: ((this.stat.assure.cnt_c / total) * 100).toFixed(2),
        },
        {
          cnt: this.stat.assure.cnt_e,
          l: "Enfants",
          p: ((this.stat.assure.cnt_e / total) * 100).toFixed(2),
        },
      ];
    },
  },
  mounted() {
    let url = `data/assure/stat/${this.numHolding}`;

    if (this.$route.params.subPage === "ea") {
      url = `data/assure/stat/${this.numHolding}/${this.numEntreprise}`;
    }
    if (this.$route.params.subPage === "ca") {
      url = `data/assure/stat/${this.numHolding}/${this.numEntreprise}/${this.numContrat}`;
    }

    this.axios.get(url).then((r) => {
      this.stat = r.data;
      setTimeout(() => {
        this.isLoaded = true;
      }, 10);
      setTimeout(() => {
        this.createBarStat("regimeStat", this.assuresStat);
        this.createBarStat("connecteStat", this.stat.connecte);
        this.createBarStat("categoryStat", this.stat.category);
        this.createBarStat("collegeStat", this.stat.college);
      }, 500);
    });
  },
};
</script>

<style>
div#categoryStat,
div#collegeStat,
div#regimeStat,
div#connecteStat {
  width: 100%;
  height: 160px;
}
.a_num {
  margin: 17px;
  margin-top: -30px;
  color: black;
  border-radius: 4px;
  text-align: center;
}

.a_num_n {
  font-size: 2rem;
  font-weight: bold;
}
.ui.two.column.grid.cust {
  margin: 0;
}
.a_group {
  background-color: white;
  padding: 1rem;
  box-shadow: 0 0 2px #9c9c9c;
  border-radius: 4px;
  width: 660px;
  margin: 20px;
  min-height: 234px;
}
.a_libelle {
  display: inline-block;
  margin-right: 10px;
}
.a_title {
  /* font-size: 1.2rem; */
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  padding: 0 10px 10px 0;
  margin-bottom: 10px;
}
.a_list {
  display: inline-block;
  vertical-align: top;
  width: 70%;
}
.a_stat {
  display: inline-block;
  vertical-align: top;
  min-width: 120px;
  width: 30%;
}
.l_list {
  display: inline-block;
  vertical-align: top;
  width: 50%;
  padding: 3px;
}
.a_n {
  font-weight: bold;
  display: inline-block;
  width: 70px;
  text-align: right;
}
.a_p {
  display: inline-block;
  width: 80px;
  text-align: right;
}
</style>
